import { UIEditor } from "./project/dev/UIEditor";
import { UIPreview } from "./project/dev/UIPreview";
import Home from "./pages/login/Login"; //登录页
import indexPage from './pages/main/layout/indexPage' //首页布局
import MainIndex from "./pages/main/MainIndex"; //首页默认内容页
import ModifyUserInfo from "./pages/main/ModifyUserInfo"; //修改信息
import ModifyPassword from "./pages/main/ModifyPassword"; //修改密码
import ParamMngPrmDef from "./pages/paramMng/ParamMngPrmDef";
import CustQueryCondition from "./pages/paramMng/CustQueryCondition";
import CustAdvanceQuery from "./pages/paramMng/CustAdvanceQuery";
import ParamMngDef from "./pages/paramMng/ParamMngDef";
import ParamMngDefDisplay from "./pages/paramMng/ParamMngDefDisplay";
import FirstLoginChgPwd from "./pages/login/FirstLoginChgPwd"; //首次登陆修改密码
import HelpDoc from "./pages/main/HelpDoc";
import Lock from './pages/lock/LockPage'
import Register from './pages/register/index'
import ChangePassword from './pages/ChangePassword/index'
import FlowChart from './pages/component/FlowChart/index'
let MainMenu = [];

//显示在content内
let noMenulist = [
  // { path: '/main/paramMngPrmDef', component: ParamMngPrmDef },
  // { path: '/main/CustQueryCondition', component: CustQueryCondition },
  // { path: '/main/custAdvanceQuery', component: CustAdvanceQuery },
  // { path: '/main/ParamMngDef', component: ParamMngDef },
  // { path: '/main/ParamMngDefDisplay', component: ParamMngDefDisplay },
];
noMenulist.forEach((item) => {
  MainMenu.push(item);
});

var menusForEach = (menus) => {
  menus.forEach((item) => {
    if (item.children) {
      menusForEach(item.children);
    } else {
      if (item.uid) {
        MainMenu.push({ path: item.routeParam, component: UIPreview });
      }
    }
  });
};

let saveLastVisitRoute = function (item) {
  let value = escape(JSON.stringify(item));
  tool.sgiStorage.set("LastVisitRoute", value);
};

let getLastVisitRoute = function () {
  let lvr = unescape(tool.sgiStorage.get("LastVisitRoute"));
  if (lvr == "undefined") {
    return;
  }
  let item = JSON.parse(lvr);
  if (item) {
    menusForEach([item]);
  }
};

let addNewPath = function (path) {
  MainMenu.push({ path: path, component: UIPreview });
};

// menusForEach(menus);
getLastVisitRoute();

MainMenu.push({ path: "/dev/uiEditor", component: UIEditor });
MainMenu.push({ path: "/dev/uiPreview", component: UIPreview });
MainMenu.push({ path: "/main/ModifyUserInfo", component: ModifyPassword });
MainMenu.push({ path: "/main/FlowChart", component: FlowChart });
//MainMenu.push({ path: "/pages/ChangePassword/index", component: ChangePassword });



//显示在整个页面
const routes = [
  {
    path: "/HelpDoc",
    component: HelpDoc,
  },
  {
    path: "/FirstLoginChgPwd",
    component: FirstLoginChgPwd,
  },

  // {
  //   path: "/ModifyPassword",
  //   component: ModifyPassword,
  // },
  {
    path: "/ModifyUserInfo",
    component: ModifyUserInfo,
  },
  {
    path: "/UIPreview",
    component: UIPreview,
  },
  // {
  //   path: "/",
  //   component: indexPage,
  // },
  {
    path: "/",
    component: Home,
  },
  {
    path: "/index.html",
    component: Home,
  },
  {
    path: "main",
    component: indexPage,
    indexRoute: { component: MainIndex },
    childRoutes: MainMenu,
  },
  {
    path: "/lock",
    component: Lock
  },
  {
    path: "/Register",
    component: Register
  },
  {
    path: "/ChangePassword",
    component: ChangePassword,
  },
  {
      path: '*',
      component: Home,
      // indexRoute: { component: MainIndex },
      childRoutes: MainMenu
  }
];

export { addNewPath, menusForEach, saveLastVisitRoute, MainMenu };
export default routes;



// WEBPACK FOOTER //
// ./apps/routes.js